'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z' });

var WatchLater = function WatchLater(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

WatchLater = (0, _pure2.default)(WatchLater);
WatchLater.muiName = 'SvgIcon';

exports.default = WatchLater;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/WatchLater.js
// module id = 3008
// module chunks = 0